import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Offcanvas,
  Modal,
} from "react-bootstrap";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Buttons } from "../components/Buttons";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import { MdOutlineClose, MdPictureAsPdf } from "react-icons/md"; // ADDED MdPictureAsPdf
import Pdf from "./Pdf";
import SalesInvoicePdfList from "./SalesInvoicePdfList"; // ADDED NEW PDF COMPONENT
import "../components/Table.css";
import moment from "moment/moment";
import companyId from "../config/companyId";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";

const ProductHistory = [
  "S.NO",
  "Date",
  "Receipt No.",
  "Name",
  "Amount",
  "Status",
];

const SalesInvoice = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [printrow, setPrintRow] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => {
    setShow(false);
    setSelectedOption("");
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const [filterData, setFilterData] = useState({
    search_text: "",
    party_name: "",
    party_id: "",
    from_date: "",
    to_date: "",
  });

  const [dropdownKey, setDropdownKey] = useState(Date.now());

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      party_name: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
  };

  const handleClearAll = () => {
    setFilterData({
      search_text: "",
      party_name: "",
      party_id: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const setLabel = (value, field) => {
    // 🛑 CHANGE 1: Store YYYY-MM-DD format in the state for API calls.
    const formattedDate = value ? moment(value).format("YYYY-MM-DD") : "";

    setFilterData({
      ...filterData,
      [field]: formattedDate,
    });
  };

  const [partySalesData, setPartySalesData] = useState([]);
  const fetchPartySalesData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      if (responseData.code === 200) {
        setPartySalesData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const [unitData, setUnitData] = useState([]);
  const fetchUnitData = async () => {
    try {
      const companyIdLocal = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyIdLocal}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartySalesData();
    fetchUnitData();
  }, []);

  const [userData, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: filterData.search_text,
            // party_name: filterData.party_name,
            party_id: filterData.party_id,
            from_date: filterData.from_date,
            to_date: filterData.to_date,
            bill_no: filterData.bill_no || "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log("Sales Invoice Data:", responseData);

      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterData]);

  const filteredUserData = userData.filter((item) => {
    const billNo = item.bill_no?.toString() || "";
    const receiptNo = item.receipt_no?.toString() || "";
    const searchText = filterData.search_text?.toString() || "";

    const isSearchMatch =
      searchText === "" ||
      billNo.includes(searchText) ||
      receiptNo.includes(searchText);

    // ✅ FIX 1: Correctly access party_name from 'item.party_details'.
    const partyName = item.party_details?.party_name?.toLowerCase() || "";
    const filterPartyName = filterData.party_name?.toLowerCase() || "";

    const isPartyMatch = partyName.includes(filterPartyName);

    // ✅ FIX 2: Specify the date format as "YYYY-MM-DD" for accurate parsing,
    // which matches the format returned by salesinvoice.php.
    const itemDate = moment(item.bill_date, "YYYY-MM-DD");
    const fromDate = filterData.from_date
      ? moment(filterData.from_date, "YYYY-MM-DD")
      : null;
    const toDate = filterData.to_date
      ? moment(filterData.to_date, "YYYY-MM-DD")
      : null;

    const isDateMatch =
      (!fromDate && !toDate) ||
      (fromDate &&
        toDate &&
        itemDate.isBetween(fromDate, toDate, "day", "[]")) ||
      (fromDate && !toDate && itemDate.isSameOrAfter(fromDate, "day")) ||
      (!fromDate && toDate && itemDate.isSameOrBefore(toDate, "day"));

    return isSearchMatch && isPartyMatch && isDateMatch;
  });

  // START OF MODIFIED/ADDED CODE

  /**
   * Fetches data for bulk PDF export, formats it, and calls openPrintView.
   */
  /**
   * Processes the currently filtered data for bulk PDF export and calls openPrintView.
   */
  const handleDownloadPdf = async () => {
    setLoading(true);

    // 🛑 MAJOR FIX: Use the already filtered data (filteredUserData) instead of calling the API again.
    const dataToExport = filteredUserData.map((item, index) => ({
      s_no: index + 1,
      bill_no: item.bill_no,
      bill_date: moment(item.bill_date).format("DD-MM-YYYY"),
      party_name: item.party_name,
      gst_no: item.party_details?.gst_no,
      // MODIFIED: Bill Amount (item.total in PDF component) now uses item.sum_total (Taxable Amount)
      total: item.sub_total - item.discount_amount,
      // Calculate GST Amount: final_amount - taxable_amount
      gst_amount: item.gst_amount,
      // Final Amount (item.to_amount in PDF component) uses item.total (Final Charged Amount)
    }));

    if (dataToExport.length > 0) {
      await openPrintView(dataToExport, "BulkExport");
    } else {
      alert("No records found matching the current filter criteria.");
    }

    setLoading(false);
  };

 const openPrintView = async (rowData, type) => {
  const isBulkExport = type === "BulkExport";
  const PdfComponent = isBulkExport ? SalesInvoicePdfList : Pdf;

  console.log("rowData", rowData);

  // 1. Resolve units manually before passing to PDF component
  // This ensures the labels are baked into the data even if prop-passing has issues
  const resolveUnit = (p, allUnits) => {
    if (!p || !allUnits) return "";
    const unitId = p.unit || p.unit_id || p.units_id || p.u_id || p.product_unit_id;
    if (!unitId) return p.unit_name || "";
    const matched = allUnits.find(u => String(u.unit_id) === String(unitId) || String(u.id) === String(unitId));
    return matched ? (matched.unit_name || matched.short_name || "") : (p.unit_name || "");
  };

  const enrichedData = {
    ...rowData,
    product: (rowData.product || []).map(p => ({
      ...p,
      resolved_unit_name: resolveUnit(p, unitData)
    }))
  };

  const blob = await pdf(<PdfComponent data={enrichedData} type={type} units={unitData} />).toBlob();

  const party =
    rowData?.party_details?.party_name ||
    rowData?.party_name ||
    "Party";

  const bill =
    rowData?.bill_no ||
    rowData?.receipt_no ||
    "Invoice";

  const filename = `${party}_${bill}.pdf`
    .replace(/\s+/g, "_")
    .replace(/[^\w\-\.]/g, "");

  const file = new File([blob], filename, { type: "application/pdf" });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};



  const handleOptionChange = (type) => {
    if (selectedRow) {
      openPrintView(selectedRow, type); // ✅ type is now string
    }
    setShowModal(false);
  };

  const handleSalesInvoicePrintClick = (rowData) => {
    setSelectedRow(rowData);
    setShowModal(true);
  };
  // END OF MODIFIED/ADDED CODE

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (loading) {
    return <LoadingSpinner message="Loading Sales Invoice..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div className="main px-2 my-3">
          <div className="mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle={"Sale Invoice"} />
              </Navbar.Brand>
              <Nav className="ms-auto">
                {/* PDF Icon Button ADDED HERE */}
                <span className="mx-2 py-2">
                  <Buttons
                    lable={
                      <MdPictureAsPdf
                        style={{ fontSize: "1.5rem" }}
                        title="Download Sales Invoice PDF List"
                      />
                    }
                    onClick={handleDownloadPdf}
                  />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>Filter</>} onClick={showFilter} />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>Clear</>} onClick={handleClearAll} />
                </span>
              </Nav>
            </Navbar>
          </div>
          <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
            <Offcanvas.Body>
              <Row>
                <Col lg="6">
                  <PageTitle PageTitle={<>Sales Invoice</>} />
                </Col>
                <Col lg="6" className="align-self-center">
                  <div className="text-end">
                    <Buttons
                      onClick={closeFilter}
                      lable={
                        <>
                          <MdOutlineClose />
                        </>
                      }
                    ></Buttons>
                  </div>
                </Col>
              </Row>
              <div>
                <div className="py-3">
                  <TextInputForm
                    labelname={"Search Receipt"}
                    placeholder={"Search Receipt"}
                    name="search_text"
                    value={filterData.search_text}
                    onChange={(e) => handleChange(e, "search_text")}
                  ></TextInputForm>
                </div>
                <div className="py-3">
                  <TextInputForm
                    placeholder={"Party Name"}
                    labelname={"Party Name"}
                    name="party_name"
                    value={filterData.party_name}
                    onChange={(e) => handleChange(e, "party_name")}
                  />
                </div>
                <Row>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "from_date")}
                        selectedDate={filterData.from_date}
                        calenderlabel="From Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "to_date")}
                        selectedDate={filterData.to_date}
                        calenderlabel="To Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons
                        lable={"Apply"}
                        onClick={() => {
                          closeFilter();
                        }}
                      ></Buttons>
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons lable={"Clear"} onClick={clearFilter}></Buttons>
                    </div>
                  </Col>
                </Row>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="main p-3">
          <div className="py-1 mx-2">
            <Navbar>
              <Container fluid className="px-0">
                <Navbar.Brand>
                  <PageTitle PageTitle={"Transactions"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  <span className="mx-2 py-2">
                    <Buttons
                      lable={<>Add New</>}
                      onClick={() => navigate("/console/sales/invoice/create")}
                    />
                  </span>
                </Nav>
              </Container>
            </Navbar>
          </div>
          <div className="py-2 c-table table-scroll mx-2">
            <TableUI
              headers={ProductHistory}
              body={filteredUserData}
              type="salesinvoice"
              handleEditClick={handleSalesInvoicePrintClick}
              pageview={"yes"}
              onDelete={fetchData}
            ></TableUI>
          </div>
        </div>
      </Container>
      <Modal
        size="xs"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header className="position-relative ">
          <Modal.Title className="fs-5 text-center w-100 mt-2 mb-2">
            Print Type
          </Modal.Title>
          <MdOutlineClose
            className="position-absolute end-0 top-0 mt-2 me-2"
            style={{ cursor: "pointer", fontSize: "1.5rem" }}
            onClick={() => setShowModal(false)}
            aria-label="Close Print Type Modal"
          />
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md={4}>
                <input
                  type="radio"
                  id="original"
                  name="fav_language"
                  value="Original"
                  onChange={(e) => handleOptionChange(e.target.value)}
                />
                <label htmlFor="original">Original</label>
              </Col>
              <Col md={4}>
                <input
                  type="radio"
                  id="duplicate"
                  name="fav_language"
                  value="Duplicate"
                  onChange={(e) => handleOptionChange(e.target.value)}
                />
                <label htmlFor="duplicate">Duplicate</label>
              </Col>
              <Col md={4}>
                <input
                  type="radio"
                  id="triplicate"
                  name="fav_language"
                  value="Triplicate"
                  onChange={(e) => handleOptionChange(e.target.value)}
                />
                <label htmlFor="triplicate">Triplicate</label>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SalesInvoice;

